"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ADMIN_PERMISSION_NAME = exports.ADMIN_ROLE_NAME = exports.MAX_DEPTH = exports.MAX_LEVEL = void 0;
exports.MAX_LEVEL = 10;
exports.MAX_DEPTH = 4;
exports.ADMIN_ROLE_NAME = '관리자';
exports.DEFAULT_ADMIN_PERMISSION_NAME = '최고 관리자';
